import { render, staticRenderFns } from "./exameGeral.vue?vue&type=template&id=13b74a4c&"
import script from "./exameGeral.vue?vue&type=script&lang=js&"
export * from "./exameGeral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports